module.exports = __webpack_public_path__ + "static/media/mozn.b1d72ab7.png";